



































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import ProductState from '@/components/Products/ProductState.vue';
import GeneralPayeeSettings from '@/models/Products/ProductSettings/DefaultSettings/GeneralPayee/GeneralPayeeSettings';
import GeneralPayeeSettingsEditDialog from '@/components/Products/ProductSettings/DefaultSettings/GeneralPayee/GeneralPayeeSettingsEditDialog.vue';
import EntityType from '@/models/Shared/EntityType';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'GeneralPayeeSettingsRead', components: { ProductState, GeneralPayeeSettingsEditDialog } })
export default class extends SaascadaVueFieldGroup {

    EntityType = EntityType;
    PermissionUtils = PermissionUtils;

    @Prop({required: true })
    settings: GeneralPayeeSettings;

    @Prop({required: true})
    entityType: EntityType;

    get settingsAvailable() {
        return (this.settings !== undefined);
    }
}
